import {
  CLEAR_CUSTOMER,
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER,
  GET_CUSTOMER,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMERS_PAGINATION
} from "../constants/Customers";

export const getCustomers = (page, perPage = 10, search = "") => {
  return {
    type: GET_CUSTOMERS,
    perPage,
    search,
    page
  }
}

export const createCustomer = (data, history) => {
  return {
    type: CREATE_CUSTOMER,
    data,
    history
  }
}

export const createCustomerSuccess = (customer) => {
  return {
    type: CREATE_CUSTOMER_SUCCESS,
    customer,
  }
}

export const updateCustomer = (id, data, history) => {
  return {
    type: UPDATE_CUSTOMER,
    id,
    data,
    history
  }
}

export const updateCustomerSuccess = (id, data) => {
  return {
    type: UPDATE_CUSTOMER_SUCCESS,
    id,
    data,
  }
}

export const clearCustomer = (id) => {
  return {
    type: CLEAR_CUSTOMER,
    id,
  }
}

export const getCustomersSuccess = (customers, total, from, to) => {
  return {
    type: GET_CUSTOMERS_SUCCESS,
    customers,
    from,
    to,
    total
  }
}

export const updateCustomersPagination = (page, perPage = 10, search = "") => {
  return {
    type: UPDATE_CUSTOMERS_PAGINATION,
    perPage,
    search,
    page
  }
}

export const getCustomer = (id) => {
  return {
    type: GET_CUSTOMER,
    id
  }
}

export const deleteCustomer = (id, page, perPage = 10, search = "") => {
  return {
    type: DELETE_CUSTOMER,
    id,
    perPage,
    search,
    page
  }
}

export const getCustomerSuccess = (data) => {
  return {
    type: GET_CUSTOMER_SUCCESS,
    customer: data
  }
}